import React from "react";
import { StyledCell } from "./index";

const SantaCell = () => {
  return (
    <StyledCell>
      <img src="/santa.png" alt="santa" />
    </StyledCell>
  );
};

export default SantaCell;
